import { render, staticRenderFns } from "./Committemember.vue?vue&type=template&id=2204b970&scoped=true"
import script from "./Committemember.vue?vue&type=script&lang=js"
export * from "./Committemember.vue?vue&type=script&lang=js"
import style0 from "./Committemember.vue?vue&type=style&index=0&id=2204b970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2204b970",
  null
  
)

export default component.exports